export type ActivityValue = {
  type?: string
  modal?: string
  view?: string
  withToggle?: boolean
  overlayTitle?: string
  toggleCopy?: string
  [key: string]: unknown
}

const RIGHT_TO_RENT_OVERLAY = 'right-to-rent'
const RIGHT_TO_RENT_OVERLAY_COPY = 'Prove your right to rent'
const CURRENCY_DETAILS_MODAL = 'currency-details'
const CURRENCY_OVERLAY_COPY = 'Enter your income details'
const ADDITIONAL_DETAILS_MODAL = 'additional-details'
const ADDITIONAL_DETAILS_OVERLAY_COPY = "Explain why you can't provide this"
const SUBJECT_DETAILS_MODAL = 'subject-details'
const SUBJECT_DETAILS_OVERLAY_COPY = 'Confirm your details'
const TERMS_AND_CONDITIONS_MODAL = 'terms-and-conditions'

export type RoutedModal =
  | { action: 'overlay'; model: ActivityValue }
  | { action: 'ignore'; model: ActivityValue }

const withToggle = (value: ActivityValue, overlayTitle: string): ActivityValue => ({
  ...value,
  withToggle: true,
  overlayTitle,
  toggleCopy: overlayTitle,
})

export const routeModalActivity = (
  value: ActivityValue | undefined,
): RoutedModal | undefined => {
  if (value === undefined || value === null || typeof value !== 'object') {
    return undefined
  }

  if (value.modal === RIGHT_TO_RENT_OVERLAY) {
    return { action: 'overlay', model: withToggle(value, RIGHT_TO_RENT_OVERLAY_COPY) }
  }

  if (value.modal === ADDITIONAL_DETAILS_MODAL) {
    return {
      action: 'overlay',
      model: withToggle(value, ADDITIONAL_DETAILS_OVERLAY_COPY),
    }
  }

  if (value.modal === CURRENCY_DETAILS_MODAL) {
    return { action: 'overlay', model: withToggle(value, CURRENCY_OVERLAY_COPY) }
  }

  if (value.modal === SUBJECT_DETAILS_MODAL) {
    return { action: 'overlay', model: withToggle(value, SUBJECT_DETAILS_OVERLAY_COPY) }
  }

  if (value.modal === TERMS_AND_CONDITIONS_MODAL) {
    return {
      action: 'overlay',
      model: {
        ...value,
        withToggle: true,
        toggleCopy: 'Continue',
      },
    }
  }

  if (value.type === 'ShowOverlay') {
    return { action: 'overlay', model: { ...value } }
  }

  if (value.type === 'ShowModal') {
    return { action: 'ignore', model: { ...value } }
  }

  return undefined
}
